import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) {
  firebase.initializeApp({
    name: "MB", 
    apiKey: "AIzaSyBQa4FHIMW-HwuAf2rKQC7cGhRfp0lZPrw",
    authDomain: "medialibrary-dev.firebaseapp.com",
    databaseURL: "https://medialibrary-dev-default-rtdb.firebaseio.com",
    projectId: "medialibrary-dev",
    storageBucket: "medialibrary-dev.appspot.com",
    messagingSenderId: "689765869117",
    appId: "1:689765869117:web:251f7ee6a688dc3f7e6c54",
    measurementId: "G-7SYEM2WWWJ",
  });
}else {
  firebase.app("[DEFAULT]"); // if already initialized, use that one
}
export const fs = firebase.firestore();